import React from "react";
// import art from "../assets/31c8ba160265427ed823e59e71d06ae1.jpeg";
// import art2 from "../assets/5292be15fdacc619a48bfcbb1d90aecb.jpeg";
// import art3 from "../assets/download.jpeg";
const CardGroub = ({ description, title, children }) => {
  return (
    <div
      className="card d-flex flex-column pt-1 pb-4  justify-content-center align-items-center border-0  "
      style={{
        minHeight: "310px",
        height: "352px",
        width: "305px",
      }}
    >
       <div
        style={{ width: "90%",height:"250px", borderRadius: "70px" }}
        className="card-img  mt-2 mb-1"
      >
   
          
      {children}

    </div>
      <div
        className="card-body text-truncut"
        style={{ textOverflow: "ellipsis", overflow: "hidden" }}
      >
        <h5 className="card-title" style={{ fontSize: "18px",fontWeight:"bold" }}>
          {title}
        </h5>
        <p
          className="card-text mb-3 text-truncut "
          style={{ fontSize: "14px", textOverflow: "elipsis" }}
        >
          {description}{" "}
        </p>
      </div>
    </div>
  );
};

export default CardGroub;
